// extracted by mini-css-extract-plugin
export var footer = "_o1-0";
export var inherit = "_o1-1";
export var input = "_o1-2";
export var modalContent = "_o1-3";
export var quillEditor = "_o1-4";
export var subtitle = "_o1-5";